import * as React from 'react';
import { Link } from 'react-router-dom';
import { ClickTracker } from 'bernie-analytics';

import { UitkIcon } from 'uitk-react-icons';
import { PropertyDetailsSegment } from 'components/infosite/policies/internals/property-details-segment';

const LinkTracked = ClickTracker(Link);

export const HisTopEntry = ({ listClasses, headerTitle, jsEnabled, linkClassNames, routeStore, placeholder }) => (
  <PropertyDetailsSegment
    errorBoundaryLabel="section-info-find-answers-1"
    dataStid="section-info-find-answers-1"
    rootClassName="info-find-answers"
    title={null}
    isToggleHidden={false}
  >
    <div className={listClasses}>
      <div className="uitk-grid property-policies-check-in all-y-padding-zero">
        <div className="uitk-grid">
          <div className="uitk-cell all-cell-1-1 uitk-type-regular uitk-type-300">
            <span className="all-r-margin-one">{headerTitle}</span>
            <LinkTracked
              linkName="Open Find Answers"
              disabled={!jsEnabled}
              rfrr="AskQuestion.FindAnswersTopEntry"
              className={linkClassNames.join(' ')}
              to={{
                search: routeStore.mergeQueryString(routeStore.search, { pwaDialogNested: 'findAnswers' })
              }}
            >
              <UitkIcon name="search" />
              {placeholder}
            </LinkTracked>
          </div>
        </div>
      </div>
    </div>
  </PropertyDetailsSegment>
);

HisTopEntry.displayName = 'HisTopEntry';
